/* eslint no-dupe-keys: 0 */
import {BODY_TEXT_COLOR} from '../../config/colors';

const styles = {
  header: {
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: '5px 0px 5px',
    fontWeight: 700,
    color: BODY_TEXT_COLOR,
    fontSize: '30px',
    fontFamily: 'Futura-Bold'
  },
  textFieldStyle: {width: '290px'},
  wrapper: {
    display: '-webkit-box',
    display: '-ms-flexbox',
    display: 'flex',
    MsFlexWrap: 'wrap',
    flexWrap: 'wrap',
    padding: '0 10px',
    width: '100%'
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/HandsFreeSearch/defaultStyles.js